import Link from "next/link";
import React from "react";
import TeamLogo from "@/components/team/logo";
import { TeamBasic } from "common";

/**
 * Displays a versus from the perspective of a specific team.
 */
export default function GameTablePerspectiveVersus({
  opponent,
  home,
  slug,
}: {
  opponent: TeamBasic;
  home?: boolean;
  slug?: string;
}) {
  const content = (
    <div className="flex flex-row items-center gap-2">
      <div className="w-4 flex items-center justify-end">
      <span>{home ? "vs" : "@"}</span>
      </div>
      <TeamLogo size="xs" team={opponent} />
      <div className="w-5 flex items-center justify-start">
      <span>{opponent.abbreviation}</span>
      </div>
    </div>
  );

  return slug ? (
    <Link
      href={slug}
      scroll={false}
    >
      {content}
    </Link>
  ) : (
    content
  );
}
